import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VCard,
    [
      _c(VCardTitle, [_vm._v("Release Notes")]),
      _vm._v(" "),
      _c(
        VCardText,
        [
          _vm._l(_vm.releaseNotes, function (releaseNote) {
            return [
              _c("h2", { key: releaseNote.version }, [
                _vm._v(_vm._s(releaseNote.version)),
              ]),
              _vm._v(" "),
              _c(
                VList,
                { key: releaseNote.version, attrs: { dense: "" } },
                [
                  releaseNote.newFeatures && releaseNote.newFeatures.length
                    ? _c(
                        VSubheader,
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("fas fa-plus"),
                          ]),
                          _vm._v("\n          New Features\n        "),
                        ],
                        1,
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(releaseNote.newFeatures, function (entry) {
                    return _c(VListItem, { key: entry }, [
                      _vm._v(_vm._s(entry)),
                    ])
                  }),
                  _vm._v(" "),
                  releaseNote.improvements && releaseNote.improvements.length
                    ? _c(
                        VSubheader,
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("fas fa-arrow-up"),
                          ]),
                          _vm._v("\n          Improvements\n        "),
                        ],
                        1,
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(releaseNote.improvements, function (entry) {
                    return _c(VListItem, { key: entry }, [
                      _vm._v(_vm._s(entry)),
                    ])
                  }),
                  _vm._v(" "),
                  releaseNote.fixes && releaseNote.fixes.length
                    ? _c(
                        VSubheader,
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("fas fa-check"),
                          ]),
                          _vm._v("\n          Bug fixes\n        "),
                        ],
                        1,
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(releaseNote.fixes, function (entry) {
                    return _c(VListItem, { key: entry }, [
                      _vm._v(_vm._s(entry)),
                    ])
                  }),
                ],
                2,
              ),
              _vm._v(" "),
              _c("hr", {
                staticClass: "mb-3",
                staticStyle: { opacity: "0.3" },
              }),
            ]
          }),
        ],
        2,
      ),
    ],
    1,
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }